// EmailJS Configuration
// Replace these values with your actual EmailJS credentials

export const EMAILJS_CONFIG = {
    // Your EmailJS Service ID
    SERVICE_ID: 'service_obf8536',

    // Your EmailJS Template ID
    TEMPLATE_ID: 'template_ryfjthz',

    // Your EmailJS Public Key
    PUBLIC_KEY: '_ejThy2b8IReTMLnQ',

    // Email address where form submissions will be sent
    TO_EMAIL: 'sales@avenisglobal.com',
};

// EmailJS Setup Instructions:
// 1. Go to https://www.emailjs.com/ and create an account
// 2. Create a new service (Gmail, Outlook, etc.)
// 3. Create an email template with the following variables:
//    - {{from_name}} - Sender's name
//    - {{from_email}} - Sender's email
//    - {{company}} - Company name (optional)
//    - {{subject}} - Email subject
//    - {{message}} - Email message
//    - {{to_email}} - Recipient email
// 4. Get your Service ID, Template ID, and Public Key from EmailJS dashboard
// 5. Replace the placeholder values above with your actual credentials
// 6. Update the Contact.js file to import and use these values

// Example template content for EmailJS:
/*
Subject: New Contact Form Submission - {{subject}}

From: {{from_name}} ({{from_email}})
Company: {{company}}
Subject: {{subject}}

Message:
{{message}}

---
This message was sent from the Avenis Global contact form.
*/
